import {
  Action,
  ActionType,
  IDepartmentListResponse,
} from "models/stressCheck/departmentList";

import createReducer from "redux/createReducer";

export interface IDepartmentListReducerType {
  loading: boolean;
  error?: any;
  stressDepartmentListResponse?: IDepartmentListResponse;
}

const defaultState: IDepartmentListReducerType = {
  loading: false,
  error: null,
  stressDepartmentListResponse: undefined,
};

export const stressDepartmentListReducer =
  createReducer<IDepartmentListReducerType>(defaultState, {
    [ActionType.STRESS_DEPARTMENT_LIST](state: IDepartmentListReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.STRESS_DEPARTMENT_LIST_ERROR](
      state: IDepartmentListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        deleted: false,
        error: action.payload,
      };
    },

    [ActionType.STRESS_DEPARTMENT_LIST_SUCCESS](
      state: IDepartmentListReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        deleted: true,
        stressDepartmentList: action.payload,
      };
    },
  });
